module.exports = __webpack_public_path__ + "static/media/new-serena.553305a5.png";